function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  rx: 2,
  fill: "#99A6B0"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.31882 4.60553C8.92785 4.60553 9.42157 4.11181 9.42157 3.50278C9.42157 2.89374 8.92785 2.40002 8.31882 2.40002C7.70978 2.40002 7.21606 2.89374 7.21606 3.50278C7.21606 4.11181 7.70978 4.60553 8.31882 4.60553Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.42148 6.55326V5.73145H7.1256H5.6001V6.84307V7.95471H7.1256H7.26594V10.0767V13.6H8.34376H9.42156V10.0767V6.55326H9.42148Z",
  fill: "white"
});

const SvgIncortaVIcon = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIncortaVIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/incorta-v-icon.c0ce8a13.svg";
export { ForwardRef as ReactComponent };